import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Badge,
  Button,
} from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Breadcrumbs from "components/Common/Breadcrumb";
import Spinners from "components/Common/Spinner";
import { fetchKelasOnlineUser } from "services/kelasOnlineService";

const UserKelasOnline = () => {
  document.title = "Kelas Online | Tryout App";

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    per_page: 10,
    total: 0,
    last_page: 1,
  });

  const fetchData = async (pageToFetch = 1) => {
    try {
      setLoading(true);
      const response = await fetchKelasOnlineUser({ page: pageToFetch });
      if (response.success) {
        // Jika ini halaman pertama, ganti data. Jika tidak, tambahkan data baru.
        setData((prevData) =>
          pageToFetch === 1 ? response.data : [...prevData, ...response.data]
        );
        setPagination(response.meta);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Gagal memuat data kelas online.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleLoadMore = () => {
    if (pagination.page < pagination.last_page) {
      fetchData(pagination.page + 1);
    }
  };

  const formatTanggal = (isoString) => {
    const date = new Date(isoString);
    if (isNaN(date.getTime())) {
      return isoString;
    }
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString("id-ID", options);
  };

  const getStatusKelas = (classDate, endTime, url) => {
    const classEndTime = new Date(classDate);
    const [hours, minutes] = endTime.split(":");
    classEndTime.setHours(hours, minutes, 0);

    const now = new Date();

    if (now > classEndTime || !url) {
      return { label: "Telah Berakhir", color: "secondary" };
    }
    return { label: "Belum Dimulai", color: "success" };
  };

  const handleMulaiKelas = (url) => {
    if (url) {
      window.open(url, "_blank");
    } else {
      toast.warn("Kelas telah berakhir.");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Kelas Online" breadcrumbItem="List Kelas" />

          {loading && data.length === 0 ? (
            <div className="text-center py-5">
              <Spinners color="primary" />
            </div>
          ) : data.length === 0 ? (
            <div className="text-center py-5">
              <p>Belum ada kelas online tersedia.</p>
            </div>
          ) : (
            <Row className="justify-content-center">
              {data.map((kelas) => {
                const status = getStatusKelas(kelas.class_date, kelas.end_time, kelas.url);
                return (
                  <Col xl="4" md="6" key={kelas.id} className="mb-4">
                    <Card className="h-100 shadow-sm border-0">
                      <CardHeader className="bg-white d-flex justify-content-between align-items-center border-bottom-dashed">
                        <div className="d-flex align-items-center">
                          <i className="bx bxs-calendar-plus font-size-20 me-2 text-primary" />
                          <h5 className="mb-0 card-title fw-bold">Kelas Online</h5>
                        </div>
                        <Badge color={status.color} className="font-size-12">
                          {status.label}
                        </Badge>
                      </CardHeader>
                      <CardBody className="d-flex flex-column">
                        <h4 className="card-title text-truncate fw-bold">{kelas.title}</h4>
                        <div className="text-muted mt-2">
                          <p className="mb-1">
                            <i className="mdi mdi-calendar-blank-outline me-2 text-muted" />
                            {formatTanggal(kelas.class_date)}
                          </p>
                          <p className="mb-1">
                            <i className="mdi mdi-clock-outline me-2 text-muted" />
                            {kelas.start_time.slice(0, 5)} - {kelas.end_time.slice(0, 5)} WIB
                          </p>
                        </div>
                        <div className="mt-auto pt-3">
                           <Button
                              color="primary"
                              block
                              onClick={() => handleMulaiKelas(kelas.url)}
                              disabled={!kelas.url}
                           >
                              Mulai Kelas <i className="mdi mdi-arrow-right ms-1" />
                           </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          )}

          {/* Tombol Load More */}
          {!loading && data.length > 0 && pagination.page < pagination.last_page && (
            <div className="text-center mt-4">
              <Button color="primary" onClick={handleLoadMore}>
                Muat Lebih Banyak
              </Button>
            </div>
          )}
        </Container>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </React.Fragment>
  );
};

export default UserKelasOnline;